import Popup from "reactjs-popup";

import { cn } from "../../utils/utils";

const AlertButton = ({ children, className, refetch, onClick, disabled = false }) => {
  // Handle confirm action
  const handleYes = (e, close) => {
    e.preventDefault();
    e.stopPropagation();

    onClick();

    close(); // Close popup

    if (typeof refetch === "function") {
      refetch();
    }
  };

  return (
    <Popup
      trigger={
        <button className={cn("", className)} disabled={disabled}>
          {children}
        </button>
      }
      modal
      nested
      closeOnDocumentClick={false}
    >
      {(close) => (
        <div
          dir="rtl"
          className=" p-2 bg-neutral-00 shadow-xl rounded-lg border border-gray-300 z-50 transition-shadow duration-300 flex flex-col gap-2"
        >
          <p className="text-dark font-semibold">آیا مطمئن هستید؟</p>
          <div className="flex justify-center gap-2 p-2">
            <button onClick={() => close()} className="btn-cancel">
              انصراف
            </button>
            <button onClick={(e) => handleYes(e, close)} className="btn-container">
              تایید
            </button>
          </div>
        </div>
      )}
    </Popup>
  );
};

export default AlertButton;
